import React, { useState, useEffect } from "react";
import androidIc from "../../Images/android-white.png";
import appstoreWhite from "../../Images/apple.png";
import QrCode from "../../Images/qr-code2.png";
import "./DownloadAndroid.scss";
import "./FileDownloadButtonAndroid.scss";

const DownloadAndroid = () => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href ="https://firebasestorage.googleapis.com/v0/b/chatandmoney-3033.appspot.com/o/uploads%2FChatandmoney0.01.08.apk?alt=media&token=726beb4a-2c83-4642-8835-cdff5a43086b";
    link.download = "chatandmoney.apk";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="androidWrapper">
      {/* android box componenet */}

      <div className="androidBox" onClick={handleDownload}>
        <div className="androidIconContainer">
          <img src={androidIc} className="androidIcon" alt="Logo" />
          <div className="buttonAndroid">
            <button className="androidTextlogo"> Android app</button>
          </div>
        </div>
      </div>
      {/* ios box componenet */}
      <div className="androidBox">
        <div className="androidIconContainer">
          <img src={appstoreWhite} className="androidIcon" alt="Logo" />
          <div className="buttonAndroid">
            <button className="androidTextlogo">iOS app</button>
          </div>
        </div>
        <div className="buttonComingsoon">
          <button className="androidTextlogoComingsoon">Coming Soon*</button>
        </div>
      </div>
      {/* Web box componenet */}

      <img src={QrCode} className="QrCode" alt="Logo" />
    </div>
  );
};

export default DownloadAndroid;
